import { Hourglass } from "react-loader-spinner";
import {
  CheckIcon,
  ClockIcon,
  PeopleIcon,
  PersonStandingIcon,
} from "../../../images/icons/icons";

const TotalSubscriptionsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3h18v18H3V3z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path d="M9 9h6v6H9V9z" fill="currentColor" />
    <circle cx="6" cy="6" r="1" fill="currentColor" />
    <circle cx="18" cy="6" r="1" fill="currentColor" />
    <circle cx="6" cy="18" r="1" fill="currentColor" />
    <circle cx="18" cy="18" r="1" fill="currentColor" />
  </svg>
);

const MonthlyPlanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M16 2v4M8 2v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
    <circle cx="9" cy="16" r="1" fill="currentColor" />
    <circle cx="15" cy="16" r="1" fill="currentColor" />
    <path d="M7 13h2v2H7v-2z" fill="currentColor" />
  </svg>
);

const QuarterlyPlanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M16 2v4M8 2v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
    <rect x="6" y="13" width="3" height="3" fill="currentColor" />
    <rect x="10.5" y="13" width="3" height="3" fill="currentColor" />
    <rect x="15" y="13" width="3" height="3" fill="currentColor" />
  </svg>
);

const HalfYearlyPlanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M16 2v4M8 2v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
    <path
      d="M3 16h9"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M13 16h8"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeDasharray="2,2"
    />
    <circle cx="12" cy="16" r="2" fill="currentColor" />
  </svg>
);

const YearlyPlanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M16 2v4M8 2v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
    <rect x="6" y="13" width="12" height="6" fill="currentColor" rx="1" />
    <circle cx="12" cy="16" r="2" fill="white" />
    <path
      d="M10.5 16L11.5 17L13.5 15"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RenewalReminderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M12 7v5l3 3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8.5 8.5L7 7M15.5 8.5L17 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="4" r="1" fill="currentColor" />
    <circle cx="20" cy="12" r="1" fill="currentColor" />
    <circle cx="12" cy="20" r="1" fill="currentColor" />
    <circle cx="4" cy="12" r="1" fill="currentColor" />
  </svg>
);

export const getCardIcon = (key) => {
  switch (key) {
    case "total":
      return <TotalSubscriptionsIcon />;
    case "regular_subscriptions":
      return <PeopleIcon />;
    case "personal_training":
      return <PersonStandingIcon />;
    case "monthly":
      return <MonthlyPlanIcon />;
    case "quaterly":
      return <QuarterlyPlanIcon />;
    case "half_yearly":
      return <HalfYearlyPlanIcon />;
    case "yearly":
      return <YearlyPlanIcon />;
    case "renewal_reminders":
      return <RenewalReminderIcon />;
    case "total_resolved":
    case "total_bca_completed":
      return <CheckIcon color={getCardIconType(key) || ""} />;
    case "total_not_resolved":
    case "total_bca_pending":
      return <Hourglass />;
    case "total_pt_trial_stuck":
      return (
        <ClockIcon color={getCardIconType(key) === "red" ? "#dc2626" : ""} />
      );
    default:
      return <TotalSubscriptionsIcon />;
  }
};

export const getCardIconType = (key) => {
  switch (key) {
    case "total":
      return "blue";
    case "regular_subscriptions":
    case "total_resolved":
    case "total_bca_completed":
      return "green";
    case "personal_training":
    case "half_yearly":
      return "orange";
    case "monthly":
    case "total_not_resolved":
    case "total_bca_pending":
      return "blue";
    case "quaterly":
      return "green";
    case "yearly":
      return "blue";
    case "renewal_reminders":
      return "orange";
    case "total_pt_trial_stuck":
      return "red";
    default:
      return "gray";
  }
};

export const getCardTitle = (key, from) => {
  switch (key) {
    case "total":
      return from === "pt_trial" ? "total logs" : "Total Subscriptions";
    case "regular_subscriptions":
      return "Regular Subscriptions";
    case "personal_training":
      return "Personal Training";
    case "monthly":
      return "Monthly Plans";
    case "quaterly":
      return "Quarterly Plans";
    case "half_yearly":
      return "Half Yearly Plans";
    case "yearly":
      return "Yearly Plans";
    case "renewal_reminders":
      return "Renewal Reminders";
    case "total_resolved":
      return "resolved";
    case "total_not_resolved":
      return "pending resolve";
    case "total_pt_trial_stuck":
      return "PT Trial Stuck";
    case "total_bca_pending":
      return "First BCA Pending";
    case "total_bca_completed":
      return "First BCA Completed";
    case "bca_completed_today":
      return "BCA Completed Today";
    default:
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }
};
